import script from "./language.vue?vue&type=script&setup=true&lang=ts"
export * from "./language.vue?vue&type=script&setup=true&lang=ts"

import "./language.vue?vue&type=style&index=0&id=d6f070b8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6f070b8"]])

export default __exports__